import { render, staticRenderFns } from "./userModal.vue?vue&type=template&id=04aa2bbd&scoped=true&"
import script from "./userModal.vue?vue&type=script&lang=js&"
export * from "./userModal.vue?vue&type=script&lang=js&"
import style0 from "./userModal.vue?vue&type=style&index=0&id=04aa2bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa2bbd",
  null
  
)

export default component.exports